import EventBus from './Event/index.js';
import { validators } from './utils/utils-form.js';

class AgentSignup {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$clientsInput = this.$el.find('[name="reagent_clients_list"]');
    this.$clientsCtrl = this.$el.find('[name="reagent_client_email"]');
    this.$list = this.$el.find('[data-coapplicants-ui="list"]');
    this.$itemTpl = this.$el.find('[data-coapplicants-item-tpl]');
    this.$itemTplClone = this.$itemTpl.clone();
    this.$itemRemove = this.$el.find('[data-coapplicants-ui="remove"]');

    this.clients = [];

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.onUserLoaded.bind(this));
    this.$clientsCtrl.on('keypress', this.onAddClient.bind(this));
    this.$list.on('click', '[data-coapplicants-ui="remove"]', this.onRemoveClient.bind(this));
  }

  onUserLoaded() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    this.$el.find('[name="reagent_owner_user"]').val(user.auth.email);
    this.$itemTpl.remove();
  }

  onAddClient(e) {
    if (e.which === 13) {
      e.preventDefault();
      const emailToAdd = this.$clientsCtrl.val().trim();
      if (!emailToAdd) {
        return;
      }

      const validation = [validators.email];
      let errors = [];
      validation.forEach(validator => {
        if (!validator.validate(emailToAdd)) {
          errors.push(validator.message);
        }
      });

      if (errors.length) {
        this.$clientsCtrl.addClass('form_error_field');
        errors.forEach(error => {
          const $message = $(`<div class="form_error_message">${error}</div>`);
          this.$clientsCtrl.before($message);
        });
        return;
      } else {
        this.$clientsCtrl.removeClass('form_error_field');
        this.$el.find('.form_error_message').remove();
      }

      this.clients.push(emailToAdd);

      const $item = this.$itemTplClone.clone();
      $item.attr('data-coapplicants-item', '');
      $item.find('[data-coapplicants-ui="email"]').text(emailToAdd);
      this.$list.append($item);
      
      this.$clientsInput.val(this.clients.join(', '));
      this.$clientsCtrl.val('');
    }
  }

  onRemoveClient(e) {
    e.preventDefault();
    const $item = $(e.currentTarget).closest('[data-coapplicants-item]');
    $item.remove();

    // const currentEmails = this.$input.val().split(',').map(email => email.trim());
    const emailToRemove = $item.find('[data-coapplicants-ui="email"]').text();
    this.clients = this.clients.filter(email => email !== emailToRemove);
    this.$clientsInput.val(this.clients.join(', '));
    console.log('removed: ', this.$clientsInput.val());
  }

  static init() {
    $('[data-js-component="agent_signup"]').each((i, el) => new AgentSignup(el));
  }
}

AgentSignup.init();
